/**
 * @file step3
 * @author zhaomiaoyuan
 */
import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import SubmitSuccess from '../../components/SubmitSuccess/index.tsx';
import GuideCard from '../../components/GuideCard/index.jsx';
import {rePhone} from './conf';

import './appeal.less';
const Step3 = (props) => {
    const {appealData, cleanAppeal} = props;
    const [telType, setTelType] = useState('');

    useEffect(() => {
        setTelType(
            rePhone.test(appealData.phone) && appealData.attributionType === 1
                ? '预计2个工作日内完成审核，请耐心等待，审核结果将通过短信通知您'
                : '预计2个工作日内完成审核，请耐心等待，审核结果将通过邮件通知您'
        );
    }, [appealData.phone]);

    // const guideCardTitle = {
    //     1: '个人名片认证',
    //     2: '企业号码认证'
    // };
    // const guideCardUrl = {
    //     1: '',
    //     2: ''
    // };
    // const phoneName = appealData.phoneName;
    // const company = appealData.attributionType === 2 // 非骚扰和诈骗企业
    //     && !(phoneName.indexOf('骚扰') !== -1 || phoneName.indexOf('诈骗') !== -1);
    // const person = appealData.attributionType === 1; // 个人
    // const showGuideCard = person || company;
    return (
        <div className="step-3">
            <SubmitSuccess
                listUrl="/user_center/my_appeal"
                desc={telType}
                cleanAppeal={cleanAppeal}
            />
            {/* {showGuideCard && <GuideCard
                title={guideCardTitle[appealData.attributionType]}
                url={guideCardUrl[appealData.attributionType]}
            />} */}
            <GuideCard
                title={'企业号码认证'}
                url={'/attest'}
            />
        </div>
    );
};
Step3.propTypes = {
    appealData: PropTypes.object,
    cleanAppeal: PropTypes.func
};
export default withRouter(Step3);
